/* eslint-disable @next/next/no-img-element */
"use client";
import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CommonButton from "../common/CommonButton/CommonButton";

export const dynamic = "force-dynamic";

export const GameProjectSlider = ({ content, path }) => {

    return (
        <>
            <div className="mt-10">
                <div className="w-full">
                    {content?.map((element, ind) => (
                        <div className="w-full xl:relative" key={element?.id || ind}>
                            {/* Full-width image first */}
                            <div className="xl:block hidden w-full">
                                <div className="relative w-full h-[46rem]">
                                    <img
                                        src={`/assets/${path}/${element?.image}.webp`}
                                        alt={element?.alt}
                                        className="w-full object-cover"
                                    />
                                </div>
                            </div>


                            {/* Content positioned above the image and to the left */}
                            <div className="xl:absolute md:top-28 2xl:left-44 xl:left-36 lg:left-14 xl:w-[30%] w-full sm:p-6 p-3 md:mt-2 xl:ml-10 text-center xl:text-start">
                                {/* Game Title */}
                                <h2 className="md:text-3xl text-2xl md:leading-10 leading-8 font-bold text-[#043E86] mb-2">
                                    {element?.title}
                                </h2>

                                {/* Game Description */}
                                <p className="text-[#333333] text-[15px] font-normal leading-4 xl:px-0 md:px-12">
                                    {element?.description}
                                </p>

                                {/* Middle Images (Bullets) */}
                                <div className="xl:flex hidden flex-wrap my-14 gap-2">
                                    {element?.middleImg?.map((img, index) => (
                                        <div key={index} className="h-16 w-16 relative">
                                            <img src={`/assets/${path}/${img}.webp`} alt="bullet" className="object-cover"  />
                                        </div>
                                    ))}
                                </div>

                                {/* Key Descriptions */}
                                <div className="space-y-2">
                                    {element?.keyDescription?.map((item, ind) => (
                                        <div key={item?.id || ind}>
                                            <span className="font-semibold text-black sm:text-xl text-lg sm:leading-7 leading-6 font-inter">
                                                {item?.key}:{" "}
                                            </span>
                                            <span
                                                className={`font-medium text-black sm:text-lg text-base sm:leading-6 leading-5 font-inter break-all`}
                                            >
                                                {item?.value}
                                            </span>
                                        </div>
                                    ))}
                                </div>

                                {/* Redirect Link button */}
                                {element?.btnName && element?.btnName && (
                                    <>
                                        <div className="my-3 w-full flex justify-center xl:justify-start xl:items-start mx-auto">
                                            <CommonButton
                                                href={element?.btnLink}
                                                name={element?.btnName}
                                                className="common-blue-button-style"
                                                arrow={true}
                                            />
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};